import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationsSubject = new BehaviorSubject<any>(1);
  private countSubject = new BehaviorSubject<any>(0);
  private permissionSubject = new BehaviorSubject<any>('granted')
  constructor(private apiService: ApiService) { }

  getNotificationsV2(pageIndex: any, pageSize: any) {
    return this.apiService.get(`/notifications/notifications-new?pageIndex=${pageIndex}&pageSize=${pageSize}&isNoLoading=true`)
  }

  setPermission(permisison: any) {
    this.permissionSubject.next(permisison)
  }

  getPermission() {
    return this.permissionSubject.asObservable();
  }

  getPermissionValue() {
    return this.permissionSubject.value;
  }

  getUnread() {
    return this.apiService.get(`/user/notifications-new/get-unread#isNoLoading=true`);
  }

  isHaveUnread() {
    return this.apiService.get(`/notifications/is-have-unread?isNoLoading=true`);
  }

  clear(){
    return this.apiService.delete(`/user/notifications`);
  }

  readAllNotification(){
    return this.apiService.post(`/notifications/mark-all-as-read`);
  }

  setCount(count: number) {
    this.countSubject.next(count);
    // this.notificationsSubject.next(count)
  }

  increaseCount(keepCount: boolean = false) {
    var i = !keepCount ? 1 : 0;
    this.countSubject.next(this.countSubject.value + i);
  }

  getNotification() {
    return this.notificationsSubject.asObservable();
  }

  getCount() {
    return this.countSubject.asObservable();
  }

  markReadNotification(id: string) {
    return this.apiService.post('/notifications/read/' + id + `#isNoLoading=true`);
  }
}
